import React from 'react';
import AudioPlayer from "react-h5-audio-player";

function Audio({ audio }) {
    return (
        <div>
            <AudioPlayer src={audio} />
            <p id="onPlay">
                Audio darslar
                <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 0V10.184C3.67977 10.0655 3.34145 10.0032 3 10C2.40666 10 1.82664 10.1759 1.33329 10.5056C0.839943 10.8352 0.455426 11.3038 0.228363 11.8519C0.00129986 12.4001 -0.0581102 13.0033 0.0576455 13.5853C0.173401 14.1672 0.459123 14.7018 0.878681 15.1213C1.29824 15.5409 1.83279 15.8266 2.41473 15.9424C2.99667 16.0581 3.59987 15.9987 4.14805 15.7716C4.69623 15.5446 5.16477 15.1601 5.49441 14.6667C5.82405 14.1734 6 13.5933 6 13V3H13V7.184C12.6798 7.06548 12.3414 7.00323 12 7C11.4067 7 10.8266 7.17595 10.3333 7.50559C9.83994 7.83524 9.45543 8.30377 9.22836 8.85195C9.0013 9.40013 8.94189 10.0033 9.05764 10.5853C9.1734 11.1672 9.45912 11.7018 9.87868 12.1213C10.2982 12.5409 10.8328 12.8266 11.4147 12.9424C11.9967 13.0581 12.5999 12.9987 13.1481 12.7716C13.6962 12.5446 14.1648 12.1601 14.4944 11.6667C14.8241 11.1734 15 10.5933 15 10V0H4Z"
                        fill="#4ECB71"
                    />
                </svg>
            </p>
        </div>
    );
}

export default Audio;